module.exports = __webpack_public_path__ + "img/member03.1671693b.png";